module.exports = __webpack_public_path__ + "static/media/notice.ca77db12.png";